var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.001C18.0751 23.001 23 18.0761 23 12.001C23 5.92584 18.0751 1.00098 12 1.00098C5.92487 1.00098 1 5.92584 1 12.001C1 18.0761 5.92487 23.001 12 23.001Z",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.0049H13C12.7348 17.0049 12.4804 16.8995 12.2929 16.712C12.1054 16.5245 12 16.2701 12 16.0049V9.50488C12 9.37228 11.9473 9.2451 11.8536 9.15133C11.7598 9.05756 11.6326 9.00488 11.5 9.00488H10",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7422 7C11.6041 7 11.4922 6.88807 11.4922 6.75C11.4922 6.61193 11.6041 6.5 11.7422 6.5",
    stroke: "#181B5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7422 7C11.8802 7 11.9922 6.88807 11.9922 6.75C11.9922 6.61193 11.8802 6.5 11.7422 6.5",
    stroke: "#181B5E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f4be54e98ee0e7461af9305bf575edb8.svg";
export { ForwardRef as ReactComponent };